var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-render',{ref:"tableRender",attrs:{"config":_vm.config,"height":"45vh","width":"80vw","rowKey":"orderNumber","rowClassName":function (ref) {
                var row = ref.row;
                var rowIndex = ref.rowIndex;

                return _vm.getUnqualifiedRowConfig({
          row: row,
          rowIndex: rowIndex,
          isNotUnqualified: _vm.isNotUnqualified(row)
        });
}},on:{"selection-change":function (e) { return (_vm.selection = e); }}}),_vm._v(" "),_c('div',[_vm._v("\n    确认移除后，本订单内将会直接移除所选项目参与人。您可在项目结算管理中重新选择该用户进行支付\n  ")]),_vm._v(" "),_c('the-footer',{attrs:{"params":_vm.delParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }